import { ANY_AUTO_MODEL_INCOMING_ITEM, ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION } from 'constants/dictionaries';

import type { TAutoModel } from 'shared/types';

import type { TPropertyKey } from './propertyKey';
import { formatKey } from './propertyKey';

export const isAutoModelValid = (model: TAutoModel | undefined): model is TAutoModel => !!model?.id && !!model?.name;

export const mapAutoModel = ({
  id,
  name,
  ...data
}: NonNullable<TAutoModel>): Dictionaries.TSelectOption<number | string, NonNullable<TAutoModel>> => {
  if (ANY_AUTO_MODEL_INCOMING_ITEM.id === id) {
    return ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION;
  }

  return {
    value: Number(id),
    label: String(name),
    data: {
      ...data,
      id,
      name,
    } as NonNullable<TAutoModel>,
  };
};

export const mapAutoModels = (
  key: TPropertyKey,
  properties?: TAutoModel[] | null,
): Dictionaries.TObjectStore<number | string, TAutoModel> => {
  const formattedKey = formatKey(key);
  if (!formattedKey) {
    return {};
  }
  return { [formattedKey]: properties?.filter(isAutoModelValid)?.map(mapAutoModel) ?? [] };
};
